const es = {
  melhous: "MELHOUS",
  "melhous.service": "Servicios",
  "melhous.item_service": "Items de Servicio",
  "melhous.special_services": "Servicios Especiales",
  "melhous.other_services": "Otros Servicios",
  "melhous.gallery_areas": "Galería",
  "melhous.title": "Título",
  "melhous.banner": "Banner",
  "melhous.desc": "Descripción",
  "melhous.address": "Dirección",
  "melhous.url": "URL",
  "melhous.wifi": "WiFi",
  "melhous.wifi_pass": "Contraseña WiFi",
  "melhous.phone": "Teléfono",
  "melhous.reception_phone": "Tel. Recepción",
  "melhous.reception_phone2": "Tel. Recepción 2",
  "melhous.reception_phone3": "Tel. Recepción 3",
  "melhous.breakfast_start": "Inicio Desayuno",
  "melhous.breakfast_end": "Fin Desayuno",
  "melhous.lunch_start": "Inicio Almuerzo",
  "melhous.lunch_end": "Fin Almuerzo",
  "melhous.meal_start": "Inicio Cena",
  "melhous.meal_end": "Fin Cena",
  "melhous.check_in": "Check-In",
  "melhous.check_out": "Check-Out",
  "melhous.title_gallery": "Título Galería",
  "melhous.desc_gallery": "Descripción Galería",
  "melhous.service.title": "Título",
  "melhous.service.icon": "Icono",
  "melhous.service.button": "Botón",
  "melhous.service.description": "Descripción",
  "melhous.item_service.title": "Título",
  "melhous.item_service.description": "Descripción",
  "melhous.item_service.icon": "Icono",
  "melhous.special_services.title": "Título",
  "melhous.special_services.image": "Imagen",
  "melhous.special_services.note": "Nota",
  "melhous.special_services.permitted": "Permitido",
  "melhous.special_services.description": "Descripción",
  "melhous.other_services.title": "Título",
  "melhous.other_services.icon": "Icono",
  "melhous.other_services.description": "Descripción",
  "melhous.gallery_areas.title": "Título",
  "melhous.gallery_areas.image": "Imagen",
  "melhous.gallery_areas.video": "Video",
  "melhous.gallery_areas.desc": "Descripción",
  "crm.customer_service": "PQRS",
  "crm.customer_service.number": "Número",
  "crm.customer_service.state": "Estado",
  "crm.customer_service.party": "Cliente",
  "crm.customer_service.customer": "Cliente",
  "crm.customer_service.address": "Dirección",
  "crm.customer_service.phone": "Teléfono",
  "crm.customer_service.city": "Ciudad",
  "crm.customer_service.case": "Caso",
  "crm.customer_service.media": "Medio",
  "crm.customer_service.description": "Descripción",
  "crm.customer_service.diagnose": "Diagnóstico",
  "crm.customer_service.response": "Respuesta",
  "crm.customer_service.cs_date": "Fecha",
  "crm.customer_service.effective_date": "Fecha Efectiva",
  "crm.customer_service.satisfaction": "Satisfacción",
  "crm.customer_service.efficacy": "Eficacia",
  "crm.customer_service.responsible_employee": "Responsable",
  "crm.customer_service.department": "Departamento",
  "crm.customer_service.notes": "Notas",
  "crm.customer_service.action_plan": "Plan de Acción",
  "crm.customer_service.category_customer": "Categoría",
  "crm.customer_service.draft": "Borrador",
  "crm.customer_service.open": "Abierto",
  "crm.customer_service.close": "Cerrado",
  "melhous.link_melhous": "Link Melhous (dirección de la app, usada en los QR)",
  "melhous.require_table_qr": "Exigir QR de Mesa",
  "melhous.guide_items": "Guía",
  "melhous.messages": "Mensajes",
  "melhous.request_types": "Tipos de Solicitud",
  "melhous.recommendations": "Recomendaciones",
  "melhous.guide_item": "Guía",
  "melhous.guide_item.section": "Sección",
  "melhous.guide_item.title": "Título",
  "melhous.guide_item.description": "Descripción",
  "melhous.guide_item.schedule": "Horario",
  "melhous.guide_item.link": "Enlace",
  "melhous.guide_item.sequence": "Secuencia",
  "melhous.guide_item.hotel": "Hotel",
  "melhous.guide_item.nearby": "Alrededores",
  "melhous.message": "Mensajes",
  "melhous.message.title": "Título",
  "melhous.message.body": "Mensaje",
  "melhous.message.kind": "Tipo",
  "melhous.message.start": "Inicio",
  "melhous.message.end": "Fin",
  "melhous.message.active": "Activo",
  "melhous.message.info": "Información",
  "melhous.message.promo": "Promoción",
  "melhous.message.alert": "Aviso",
  "melhous.request_type": "Tipos de Solicitud",
  "melhous.request_type.name": "Nombre",
  "melhous.request_type.scope": "Dónde",
  "melhous.request_type.active": "Activo",
  "melhous.request_type.sequence": "Secuencia",
  "melhous.request_type.table": "Mesa",
  "melhous.request_type.room": "Habitación",
  "melhous.request_type.both": "Mesa y Habitación",
  "melhous.request": "Solicitudes",
  "melhous.request.type": "Tipo",
  "melhous.request.type_name": "Solicitud",
  "melhous.request.scope": "Dónde",
  "melhous.request.shop": "Tienda",
  "melhous.request.place": "Lugar",
  "melhous.request.note": "Nota",
  "melhous.request.state": "Estado",
  "melhous.request.attended_date": "Fecha de Atención",
  "melhous.request.attend": "Atender",
  "melhous.request.pending": "Pendiente",
  "melhous.request.attended": "Atendida",
  "melhous.request.table": "Mesa",
  "melhous.request.room": "Habitación",
  "melhous.recommendation": "Recomendaciones",
  "melhous.recommendation.name": "Nombre",
  "melhous.recommendation.message": "Mensaje",
  "melhous.recommendation.trigger_category": "Cuando la Categoría",
  "melhous.recommendation.trigger_product": "Cuando el Producto",
  "melhous.recommendation.active": "Activo",
  "melhous.recommendation.sequence": "Secuencia",
  "melhous.services": "Servicios",
  "melhous.special_services.icon": "Icono",
  "melhous.dash.tab.home": "Inicio",
  "melhous.dash.tab.hotel": "Hotel",
  "melhous.dash.tab.engage": "Atención al huésped",
  "melhous.dash.tab.requests": "Solicitudes",
  "melhous.dash.tab.pqrs": "PQRS",
  "melhous.dash.tab.appearance": "Apariencia",
  "melhous.dash.tab.qr": "Códigos QR",
  "melhous.dash.tab.home_help": "Sigue la guía de puesta en marcha y revisa lo que está pendiente hoy.",
  "melhous.dash.tab.hotel_help": "Edita los datos del hotel.",
  "melhous.dash.tab.engage_help": "Configura el enlace de la app, la guía de estadía, los mensajes y los tipos de solicitud.",
  "melhous.dash.tab.requests_help": "Atiende los pedidos que tus huéspedes hacen desde la app.",
  "melhous.dash.tab.pqrs_help": "Responde las peticiones, quejas, reclamos y sugerencias de tus huéspedes.",
  "melhous.dash.tab.appearance_help": "Elige los colores, el logo y las secciones que verán tus huéspedes.",
  "melhous.dash.tab.qr_help": "Descarga los códigos QR para que tus huéspedes abran la app.",
  "melhous.dash.setup.title": "Pon en marcha Melhous",
  "melhous.dash.setup.help": "Sigue los pasos en orden. Se marcan solos cuando los datos están listos.",
  "melhous.dash.setup.progress": "{done} de {total} listos",
  "melhous.dash.setup.done": "Puesta en marcha lista",
  "melhous.dash.setup.show_steps": "Ver pasos",
  "melhous.dash.setup.hide_steps": "Ocultar pasos",
  "melhous.dash.setup.hotel": "Revisa los datos del hotel",
  "melhous.dash.setup.hotel_hint": "Debe haber título y teléfono, propios o heredados del hotel.",
  "melhous.dash.setup.hotel_action": "Revisar hotel",
  "melhous.dash.setup.colors": "Elige los colores",
  "melhous.dash.setup.colors_hint": "Define el color principal o usa el heredado del hotel.",
  "melhous.dash.setup.colors_action": "Elegir colores",
  "melhous.dash.setup.link": "Escribe el Link Melhous",
  "melhous.dash.setup.link_hint": "Es la dirección de la app. Los códigos QR la usan para abrirla.",
  "melhous.dash.setup.link_action": "Escribir enlace",
  "melhous.dash.setup.care": "Prepara la atención",
  "melhous.dash.setup.care_hint": "Crea tipos de solicitud y agrega mensajes o datos a la guía.",
  "melhous.dash.setup.care_action": "Preparar atención",
  "melhous.dash.setup.qr": "Imprime los QR",
  "melhous.dash.setup.qr_hint": "Descárgalos, imprímelos y márcalo aquí cuando estén listos.",
  "melhous.dash.setup.qr_action": "Ver códigos QR",
  "melhous.dash.setup.qr_printed": "Ya los imprimí",
  "melhous.dash.block.link": "Enlace y QR de mesa",
  "melhous.dash.block.link_hint": "Escribe la dirección de la app y decide si pedir en mesa exige escanear el QR.",
  "melhous.dash.block.guide": "Guía",
  "melhous.dash.block.guide_hint": "Agrega lo que el huésped debe saber del hotel y sus alrededores.",
  "melhous.dash.block.messages": "Mensajes",
  "melhous.dash.block.messages_hint": "Agrega avisos y promociones para mostrar en la app.",
  "melhous.dash.block.request_types": "Tipos de solicitud",
  "melhous.dash.block.request_types_hint": "Agrega lo que el huésped puede pedir desde la mesa o la habitación.",
  "melhous.dash.block.recommendations": "Recomendaciones",
  "melhous.dash.block.recommendations_hint": "Agrega reglas según la categoría o el producto pedido.",
  "melhous.dash.card.pending_requests": "Solicitudes pendientes",
  "melhous.dash.card.active_messages": "Mensajes activos",
  "melhous.dash.card.guide_items": "Guía",
  "melhous.dash.card.open_pqrs": "PQRS abiertas",
  "melhous.dash.hotel_notice": "Los campos vacíos usan la configuración del hotel.",
  "melhous.dash.qr.melhous": "Inicio de la app",
  "melhous.dash.qr.restaurant": "Restaurantes",
  "melhous.dash.qr.hotel": "Hotel",
  "melhous.dash.qr.melhous_hint": "Abre la página de inicio de la app.",
  "melhous.dash.qr.restaurant_hint": "Lleva a los restaurantes y sus cartas.",
  "melhous.dash.qr.hotel_hint": "Lleva a la información del hotel.",
  "melhous.dash.qr.table_notice": "Los QR por mesa y habitación se imprimen desde Tryton.",
  "melhous.dash.qr.no_link": "Falta el Link Melhous",
  "melhous.dash.qr.no_link_help": "Los códigos QR necesitan la dirección de la app. Escríbela en Atención al huésped para verlos aquí.",
  "melhous.dash.qr.no_link_action": "Ir a Atención al huésped",
  "melhous.dash.qr.download": "Descargar",
  "melhous.dash.qr.downloaded": "QR descargado",
  "melhous.dash.qr.download_error": "No se pudo descargar el QR. Recarga la página e inténtalo de nuevo.",
  "melhous.dash.qr.copy": "Copiar",
  "melhous.dash.qr.copied": "Enlace copiado",
  "melhous.dash.qr.copy_error": "No se pudo copiar. Selecciona el enlace y cópialo a mano.",
  "melhous.dash.save": "Guardar cambios",
  "melhous.dash.create": "Crear configuración",
  "melhous.dash.saved": "Guardado correctamente",
  "melhous.primary_color": "Color principal",
  "melhous.secondary_color": "Color secundario",
  "melhous.accent_color": "Color de acento",
  "melhous.text_color": "Color del texto",
  "melhous.surface_color": "Color de superficie",
  "melhous.border_color": "Color de bordes",
  "melhous.show_hotel": "Hotel",
  "melhous.show_restaurant": "Restaurantes",
  "melhous.show_pqrs": "PQRS",
  "melhous.show_reservation": "Reserva",
  "melhous.show_experiences": "Experiencias",
  "melhous.logo_link": "Link del logo",
  "melhous.dash.colors": "Colores",
  "melhous.dash.section_on": "Visible en la app",
  "melhous.dash.section_off": "Oculta en la app",
  "melhous.dash.hotel.contact": "Contacto",
  "melhous.dash.hotel.schedules": "Horarios",
  "melhous.dash.hotel.wifi": "Wi-Fi",
  "melhous.dash.hotel.breakfast": "Desayuno",
  "melhous.dash.hotel.lunch": "Almuerzo",
  "melhous.dash.hotel.dinner": "Cena",
  "melhous.dash.hotel.error": "No se pudieron cargar los datos del hotel.",
  "melhous.dash.hotel.save_error": "No se pudieron guardar los cambios.",
  "melhous.dash.sections": "Secciones",
  "melhous.dash.color.invalid": "Usa un color hexadecimal, ej. #1f3a5f",
  "melhous.dash.preview.title": "Vista previa",
  "melhous.logo": "Logo",
  "melhous.dash.card.pending_requests_hint": "Pedidos de huéspedes por atender",
  "melhous.dash.card.active_messages_hint": "Avisos visibles en la app",
  "melhous.dash.card.guide_items_hint": "Datos de la guía de estadía",
  "melhous.dash.card.open_pqrs_hint": "Casos por resolver",
  "melhous.dash.color.from_hotel": "Del hotel",
  "melhous.dash.color.clear": "Limpiar",
  "melhous.dash.color.reset": "Restablecer predeterminados",
  "melhous.dash.color.reset_hint": "Colores vacíos en el formulario. Guarda para aplicar el cambio.",
  "melhous.dash.preview.help": "Esquema básico del sitio con sus colores.",
  "melhous.dash.preview.hotel_name": "Tu hotel",
  "melhous.dash.preview.hero": "Bienvenido",
  "melhous.dash.preview.section": "Restaurantes",
  "melhous.dash.preview.card": "Restaurante",
  "melhous.dash.preview.card_action": "Ver carta",
  "melhous.dash.preview.cart": "Ver mi pedido",
  "melhous.dash.inherited.title": "Datos tomados del hotel",
  "melhous.dash.inherited.empty": "Ningún dato se está tomando de la configuración del hotel.",
  "melhous.recommendation.products": "Productos recomendados",
  "melhous.dash.hotel.data": "Datos",
  "melhous.dash.block.qr_on": "Solo con el QR impreso en la mesa",
  "melhous.dash.block.qr_off": "Sin exigir el QR de la mesa",
  "melhous.dash.image.help": "Pega el enlace de la imagen. Medida recomendada: {size} px.",
  "melhous.dash.image.error": "No se pudo cargar la imagen. Revisa el enlace.",
  "melhous.dash.list.loading": "Cargando…",
  "melhous.dash.list.load_error": "No se pudo cargar la lista.",
  "melhous.dash.list.retry": "Reintentar",
  "melhous.dash.list.edit": "Editar",
  "melhous.dash.list.delete": "Eliminar",
  "melhous.dash.list.deleting": "Eliminando…",
  "melhous.dash.list.delete_confirm": "¿Eliminar «{name}»? Esta acción no se puede deshacer.",
  "melhous.dash.list.delete_error": "No se pudo eliminar.",
  "melhous.dash.list.save": "Guardar",
  "melhous.dash.list.saving": "Guardando…",
  "melhous.dash.list.save_error": "No se pudo guardar.",
  "melhous.dash.list.cancel": "Cancelar",
  "melhous.dash.list.required": "Completa el campo {field}.",
  "melhous.dash.list.invalid_end": "El fin necesita una fecha de inicio y no puede ser anterior a ella.",
  "melhous.dash.list.untitled": "Sin título",
  "melhous.dash.list.inactive": "Inactivo",
  "melhous.dash.list.order": "Orden",
  "melhous.dash.list.order_hint": "Los números menores aparecen primero.",
  "melhous.dash.list.active_hint": "Si lo desactivas, deja de verse en la app sin borrarlo.",
  "melhous.dash.list.search": "Escribe para buscar",
  "melhous.dash.list.search_more": "Hay más resultados. Escribe más para acotar.",
  "melhous.dash.list.search_error": "No se pudo buscar. Inténtalo de nuevo.",
  "melhous.dash.list.remove_tag": "Quitar {name}",
  "melhous.dash.list.service_button": "Enlace de «Ver más detalles»",
  "melhous.dash.list.service_button_hint": "Opcional. Agrega un botón con este enlace.",
  "melhous.dash.list.services_hint": "Se muestran como secciones desplegables en la página del hotel.",
  "melhous.dash.list.services_add": "Agregar servicio",
  "melhous.dash.list.services_empty": "Agrega tu primer servicio",
  "melhous.dash.list.item_services_hint": "Si agregas ítems, la app los muestra en lugar de la descripción.",
  "melhous.dash.list.item_services_add": "Agregar ítem",
  "melhous.dash.list.item_services_empty": "Agrega el primer ítem de este servicio",
  "melhous.dash.list.item_services_blocked": "Guarda el servicio para agregarle ítems.",
  "melhous.dash.list.other_services_hint": "Se muestran como tarjetas con ícono.",
  "melhous.dash.list.other_services_add": "Agregar otro servicio",
  "melhous.dash.list.other_services_empty": "Agrega tu primer otro servicio",
  "melhous.dash.list.special_services_hint": "Se muestran como tarjetas con imagen.",
  "melhous.dash.list.special_services_add": "Agregar servicio especial",
  "melhous.dash.list.special_services_empty": "Agrega tu primer servicio especial",
  "melhous.dash.list.special_description_hint": "Separa con | para mostrarla como lista.",
  "melhous.dash.list.gallery_hint": "Fotos de los espacios del hotel.",
  "melhous.dash.list.gallery_add": "Agregar foto",
  "melhous.dash.list.gallery_empty": "Agrega tu primera foto",
  "melhous.dash.list.guide_add": "Agregar a la guía",
  "melhous.dash.list.guide_empty": "Agrega tu primer dato a la guía",
  "melhous.dash.list.messages_add": "Agregar mensaje",
  "melhous.dash.list.messages_empty": "Agrega tu primer mensaje",
  "melhous.dash.list.message_dates_hint": "Hora del hotel. Sin fechas, el mensaje se muestra siempre.",
  "melhous.dash.list.request_types_add": "Agregar tipo de solicitud",
  "melhous.dash.list.request_types_empty": "Agrega tu primer tipo de solicitud",
  "melhous.dash.list.recommendations_add": "Agregar recomendación",
  "melhous.dash.list.recommendations_empty": "Agrega tu primera recomendación",
  "melhous.dash.list.recommendation_products_hint": "Se ofrecen cuando el pedido incluye ese producto o uno de esa categoría.",
  "melhous.dash.example.link": "https://",
  "melhous.dash.example.service_title": "Ej. Recepción",
  "melhous.dash.example.service_description": "Ej. Atención las 24 horas.",
  "melhous.dash.example.item_title": "Ej. Toallas adicionales",
  "melhous.dash.example.other_title": "Ej. Lavandería",
  "melhous.dash.example.other_description": "Ej. Entrega el mismo día.",
  "melhous.dash.example.special_title": "Ej. Spa",
  "melhous.dash.example.special_description": "Ej. Sauna | Masajes | Jacuzzi",
  "melhous.dash.example.gallery_title": "Ej. Piscina",
  "melhous.dash.example.gallery_description": "Ej. Abierta de 8:00 a 20:00.",
  "melhous.dash.example.guide_title": "Ej. Piscina",
  "melhous.dash.example.guide_schedule": "Ej. 8:00 a 20:00",
  "melhous.dash.example.message_title": "Ej. Happy hour en el bar",
  "melhous.dash.example.request_name": "Ej. Llamar al mesero",
  "melhous.dash.example.recommendation_name": "Ej. Bebidas con hamburguesa",
  "melhous.dash.example.recommendation_message": "Ej. Acompáñalo con una bebida",
  "melhous.dash.icon.check": "Visto bueno",
  "melhous.dash.icon.clock": "Reloj",
  "melhous.dash.icon.wifi": "Wi-Fi",
  "melhous.dash.icon.food": "Comida",
  "melhous.dash.icon.breakfast": "Desayuno",
  "melhous.dash.icon.room_service": "Servicio a la habitación",
  "melhous.dash.icon.laundry": "Lavandería",
  "melhous.dash.icon.parking": "Parqueadero",
  "melhous.dash.icon.plane_arrival": "Llegada de avión",
  "melhous.dash.icon.plane_departure": "Salida de avión",
  "melhous.dash.icon.customer_service": "Atención al cliente",
  "melhous.dash.icon.child_carer": "Niños",
  "melhous.dash.icon.users": "Personas",
  "melhous.dash.icon.suitcase": "Equipaje",
  "melhous.dash.icon.map": "Mapa",
  "melhous.dash.icon.phone": "Teléfono",
  "melhous.dash.icon.key": "Llave",
  "melhous.dash.icon.calendar": "Calendario",
  "melhous.dash.icon.ticket": "Entrada",
  "melhous.dash.icon.shopping": "Compras",
  "melhous.dash.icon.emergency": "Emergencia",
  "melhous.dash.icon.moon": "Noche",
  "melhous.dash.icon.shield": "Seguridad",
  "melhous.dash.icon.hotel": "Hotel",
  "menu.home": "Inicio",
  "menu.hotel": "Hotel",
  "menu.appearance": "Apariencia",
  "menu.engage": "Atención al huésped",
  "menu.qr": "Códigos QR",
  "menu.requests": "Solicitudes",
  "menu.pqrs": "PQRS",
  "melhous.dash.tab.pending": "{count} pendientes",
};

export default es;
